/**
 * Theme controller — applies `data-theme` to <html>, persists choice to
 * localStorage, exposes pub/sub for components that need to re-render on
 * change. Initial value is set in index.html before first paint (no FOUC).
 */

export type Theme = "light" | "dark";

const STORAGE_KEY = "vmp:theme";

type Listener = (theme: Theme) => void;
const listeners = new Set<Listener>();

function readTheme(): Theme {
  const attr = document.documentElement.getAttribute("data-theme");
  return attr === "dark" ? "dark" : "light";
}

export function getTheme(): Theme {
  return readTheme();
}

export function setTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  try { localStorage.setItem(STORAGE_KEY, theme); } catch { /* ignore */ }
  for (const l of listeners) l(theme);
}

export function toggleTheme(): Theme {
  const next: Theme = readTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}

export function subscribeTheme(listener: Listener): () => void {
  listeners.add(listener);
  // Push current value once.
  listener(readTheme());
  return () => { listeners.delete(listener); };
}
